import { request } from './client';

export interface NotionItem {
  pageId: string;
  title: string;
  hook: string;
  cta: string;
  body: string;
  draftPost: string;
  scheduledAt: string | null;
  notionStatus: string;
  lastEditedTime: string;
  blockedReason: string | null;
  imported: boolean;
}
export interface NotionPreview {
  items: NotionItem[];
  dataSources: { id: string; name: string }[];
  dataSourceId: string | null;
  nextCursor: string | null;
}
export interface NotionSelection {
  pageId: string;
  lastEditedTime: string;
  draftPost: string;
  scheduledAt: string;
}
export function previewNotion(accountId: number, body: {
  url: string; defaultTime: string; dataSourceId?: string; cursor?: string;
}) {
  return request<NotionPreview>('/api/notion/thread-account/' + accountId + '/preview', { method: 'POST', body });
}
export function importNotion(accountId: number, items: NotionSelection[]) {
  return request<{ reservationIds: number[]; skipped: number; awaitingApproval: number }>(
    '/api/notion/thread-account/' + accountId + '/import', { method: 'POST', body: { items } });
}
